import React from 'react';

import { SettingCompactCard } from './primitives/SettingCompactCard';

export interface SettingDisplayCardProps {
  children: React.ReactNode;
  className?: string;
  'data-testid'?: string;
}

/**
 * Display-only card with left-aligned content wrapper.
 *
 * Provides flex-col wrapper for vertical content stacking.
 * Use when no edit/action functionality needed.
 */
export const SettingDisplayCard: React.FC<SettingDisplayCardProps> = ({
  children,
  className,
  'data-testid': testId,
}) => {
  return (
    <SettingCompactCard className={className} data-testid={testId}>
      <div className="flex min-w-0 flex-1 flex-col gap-2">{children}</div>
    </SettingCompactCard>
  );
};
